import type { CoreApiClient } from "../client";
import type {
  PatchMyUserRequestBody,
  PostActivateAccountRequestBody,
  PostActivateAccountResponseBody,
} from "../types/account.type";

export const createAccountMutations = (api: CoreApiClient) => {
  const { client } = api;

  const requestPasswordReset = async (email: string) => {
    const { error, response } = await client.POST("/request-password-reset", { body: { email } });
    if (error) throw new Error(`Request password reset failed [status:${response.status}]`);
  };

  const resetPassword = async (token: string, password: string) => {
    const { error, response } = await client.POST("/reset-password/{token}", {
      params: { path: { token } },
      body: { password },
    });
    if (error) throw new Error(`Reset password failed [status:${response.status}]`);
  };

  const activate = async (
    token: string,
    body: PostActivateAccountRequestBody,
  ): Promise<PostActivateAccountResponseBody> => {
    const { data, error, response } = await client.POST("/activate-account/{token}", {
      params: { path: { token } },
      body,
    });
    if (error) throw new Error(`Activate account failed [status:${response.status}]`);
    return data;
  };

  const updateProfile = async (body: PatchMyUserRequestBody) => {
    const { error, response } = await client.PATCH("/user", { body });
    if (error) throw new Error(`Update profile failed [status:${response.status}]`);
  };

  const requestPhoneValidation = async () => {
    const { error, response } = await client.POST("/phone-validation/request");
    if (error) throw new Error(`Request phone validation failed [status:${response.status}]`);
  };

  const verifyPhoneNumber = async (code: string) => {
    const { error, response } = await client.POST("/phone-validation/verify", { body: { code } });
    if (error) throw new Error(`Verify phone number failed [status:${response.status}]`);
  };

  return {
    requestPasswordReset,
    resetPassword,
    activate,
    updateProfile,
    requestPhoneValidation,
    verifyPhoneNumber,
  };
};
